import { RegistrationReady } from "../models";
import { Action } from "../models/redux";

export const ENROLLMENT_BEGIN = "ENROLLMENT_BEGIN";
export const ENROLLMENT_CANCEL = "ENROLLMENT_CANCEL";
export const ENROLLMENT_DEVICESERVER_ERROR = "ENROLLMENT_DEVICESERVER_ERROR";
export const ENROLLMENT_RESET = "ENROLLMENT_RESET";
export const ENROLLMENT_COMPLETE = "ENROLLMENT_COMPLETE";

export function begin(registrationReady: RegistrationReady) : Action {
    return { type: ENROLLMENT_BEGIN, ...registrationReady };
}

export const cancel = (): Action => ({ type: ENROLLMENT_CANCEL });
export const complete = (): Action => ({ type: ENROLLMENT_COMPLETE });
export const reset = (): Action  => ({ type: ENROLLMENT_RESET });
export const deviceServerError = (): Action => ({ type: ENROLLMENT_DEVICESERVER_ERROR });
